// extracted by mini-css-extract-plugin
module.exports = {"forAllPassengers":"forAllPassengers-3Gss1","price":"price-1NI0z","money":"money-3CpgL"};